import React, { FC, useCallback, useEffect, useState } from 'react';
import classNames from 'classnames';
import { ReactComponent as SuccessIcon } from './img/success.svg';
import { ReactComponent as ErrorIcon } from './img/error.svg';
import styles from './SuccessInfo.module.scss';
import { ReactComponent as CloseSvg } from './img/close.svg';

interface SuccessErrorInfoTypes {
  text: string;
  handleClose: () => void;
  type: 'success' | 'error';
  timeout?: number;
}

const resolveIcon = (type: 'success' | 'error') => {
  switch (type) {
    case 'success':
      return <SuccessIcon className={styles.icon} />;
    case 'error':
      return <ErrorIcon className={styles.icon} />;
  }
};

export const SuccessErrorInfo: FC<SuccessErrorInfoTypes> = ({
  text,
  type,
  handleClose,
}) => {
  const [isClosing, setIsClosing] = useState(false);

  const startClose = useCallback(() => {
    setIsClosing(true);
  }, []);

  useEffect(() => {
    const timer = setTimeout(startClose, 4000);

    return () => clearTimeout(timer);
  }, [startClose]);

  const handleAnimationEnd = () => {
    if (isClosing) {
      handleClose();
    }
  };

  return (
    <div
      className={classNames(styles.root, { [styles.root_closing]: isClosing })}
      onAnimationEnd={handleAnimationEnd}>
      <div className={styles.root__main}>
        {resolveIcon(type)}
        <p className={styles.title}>{text}</p>
      </div>
      <div className={styles.close} onClick={startClose}>
        <CloseSvg />
      </div>
    </div>
  );
};
